module.exports = __webpack_public_path__ + "static/img/video-call.55e4d25.jpg";